import BaseExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'

const ExpansionPanelSummary = BaseExpansionPanelSummary

export default ExpansionPanelSummary
